// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Xi1ktVbEhwEyjRmv {
  color: #888888;
  font-size: 14px;
  font-weight: 400;
  margin: 2px 0 16px;
}

.WfmpTaEGX5cLUdtH {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.c_KccnZHxkICtCI6 {
  font-weight: 500;
  color: #303030;
  font-size: 16px;
}

.OxMAlSEtGZsWEDCB {
  color: #888888;
  font-size: 13px;
  font-weight: 400;
}

.FJwB1zHKJw026Jqm {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888888;
  font-size: 16px;
  padding: 16px 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Manager/components/Stations/StationManagersNotification.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB","sourcesContent":[".hint {\r\n  color: #888888;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  margin: 2px 0 16px;\r\n}\r\n\r\n.managerInfo {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.managerName {\r\n  font-weight: 500;\r\n  color: #303030;\r\n  font-size: 16px;\r\n}\r\n\r\n.managerSub {\r\n  color: #888888;\r\n  font-size: 13px;\r\n  font-weight: 400;\r\n}\r\n\r\n.empty {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #888888;\r\n  font-size: 16px;\r\n  padding: 16px 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var hint = `Xi1ktVbEhwEyjRmv`;
export var managerInfo = `WfmpTaEGX5cLUdtH`;
export var managerName = `c_KccnZHxkICtCI6`;
export var managerSub = `OxMAlSEtGZsWEDCB`;
export var empty = `FJwB1zHKJw026Jqm`;
export default ___CSS_LOADER_EXPORT___;
